import { useContext, useEffect } from "react";
import { __RouterContext } from "react-router";
import useForceUpdate from "use-force-update";
import queryString from "query-string";

const useRouter = () => {
  return () => {
    const routerContext = useContext(__RouterContext);
    const forceUpdate = useForceUpdate();
    if (!routerContext) {
      throw new Error(
        "use-react-router may only be used within a react-router context."
      );
    }

    useEffect(
      () => {
        routerContext.history.listen(forceUpdate);
      },
      [routerContext]
    );

    const push = path => {
      routerContext.history.push(path);
    };

    const getQueryString = (id = false) => {
      if (id === false) {
        return queryString.parse(routerContext.location.search);
      } else {
        return queryString.parse(routerContext.location.search)[id];
      }
    };

    return {
      state: {
        location: routerContext.location,
        match: routerContext.match
      },
      push,
      getQueryString
    };
  };
};

export default useRouter;
